<template>
  <div
    class="generic-card__container"
    data-testid="generic-card"
    @click="$emit('card-click')"
  >
    <div
      class="generic-card__thumbnail"
      :style="computedThumbnail"
      data-testid="generic-thumbnail"
    />
    <p class="generic-card__title text-p-3">
      <strong>{{ title }}</strong>
    </p>
    <p class="generic-card__description text-p-4">{{ description }}</p>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GenericCard extends Vue {
  @Prop({ type: String, required: true })
  private thumbnail!: string;

  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: String, required: true })
  private description!: string;

  private get computedThumbnail() {
    const url =
      this.thumbnail ||
      'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MXwxMjA3fDB8MHxzZWFyY2h8Mnx8cmVhZGluZyUyMG5ld3N8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&w=1000&q=80';
    return { backgroundImage: `url('${url}')` };
  }
}
</script>

<style lang="less" scoped>
.generic-card {
  &__container {
    display: flex;
    flex-direction: column;
    height: 279px;
    border: 0;
    background-color: @background-primary;
    border-radius: 16px;
    cursor: pointer;
  }
  &__thumbnail {
    width: 100%;
    height: 159px;
    background-size: cover;
    background-position: center;
    z-index: 0;
    border-top-left-radius: @size-spacing-x400;
    border-top-right-radius: @size-spacing-x400;
  }
  &__title {
    color: @text-primary;
    margin: @size-spacing-x400 @size-spacing-x400 @size-spacing-x300
      @size-spacing-x400;
  }
  &__description {
    color: @text-primary;
    margin: @size-spacing-x300 @size-spacing-x400 @size-spacing-x400
      @size-spacing-x400;
  }
}
</style>
